var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('v-app',[_c('router-view'),_c('AlertBar',{ref:"alertBar"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }